/** 访问页面统计详情 */
import './index.scss'
import React from 'react';
import { connect } from 'react-redux'
import {Select, message,DatePicker} from 'antd';
import InterfaceEcharts from './components/echartsFirst'
import InterfaceEcharts2 from './components/echartsSecond'
import ComTable from './components/ComTable'
import moment from 'moment';
import api from '../../lib/api'

const { Option } = Select;
const { RangePicker } = DatePicker;
class interfaceDetails extends React.Component{
  isPageSizeChange = false;
  state = {
    dateTimeVal: null,
    loading: false,
    formFilter: {
      url: null,
      statisticsType: null,
      startDate: moment().subtract(1, 'months').add(1, 'day').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      browserType: null,
      systemType: null
    },
    tbFilter: {
      startTime: '00:00',
      endTime: '23:59',
      page: 1,
      size: 30
    },
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    },
    dataList: {
      browserTypeList: [],
      statisticsTypeList: [],
      systemTypeList: [],
      urlList: []
    },
    hourList: [],
    dayList: [],
    tbData: []
  };
  UNSAFE_componentWillMount = () => {
    this.getVisitScreen();
  };
  // 过滤条件
  getVisitScreen() {
    api.getVisitScreen().then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          dataList: Object.assign(this.state.dataList, res.data),
        }, () => {
          this.initFormFilter();
        });
      } else {
        message.error(res.message);
      }
    })
  };
  // 表格数据
  getVisitPageInfo() {
    this.setState({loading: true});
    const params = Object.assign({}, this.state.tbFilter, this.state.formFilter)
    api.getVisitPageInfo(params).then(res => {
      this.setState({loading: false});
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        });
      } else {
        message.error(res.message);
      }
    })
  };
  // 图表数据
  getVisitDetailStatistics() {
    // timeType 1 按小时统计 2 按天统计
    api.getVisitDetailStatistics({...this.state.formFilter, timeType: 1}).then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          hourList: res.data || []
        });
      } else {
        message.error(res.message);
      }
    });
    api.getVisitDetailStatistics({...this.state.formFilter, timeType: 2}).then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          dayList: res.data || []
        });
      } else {
        message.error(res.message);
      }
    })
  };
  // 初始化数据
  initFormFilter() {
    const {statisticsTypeList, urlList} = this.state.dataList;
    const filterData = JSON.parse(sessionStorage.getItem('filterData'));
    if (filterData) {
      this.handlesessionFilterData(filterData);
    } else {
      this.setState({
        formFilter: Object.assign(this.state.formFilter, {
          url: urlList[0],
          statisticsType: statisticsTypeList[0].code
        })
      }, () =>　{
        this.refreshData();
      });
    }
  };
  // 将访问页面统计 过滤条件 赋值给详情页
  handlesessionFilterData(filterData) {
    const {statisticsTypeList, urlList} = this.state.dataList;
    const {statisticsType, startDate, endDate, url} = filterData;
    this.setState({
      formFilter: Object.assign(this.state.formFilter, {
        url: url || urlList[0],
        statisticsType: statisticsType || statisticsTypeList[0].code,
        startDate,
        endDate
      })
    }, () =>　{
      this.refreshData();
    });
  };
  // 日期区间 3个月以内
  disabledDate = (current) => {
    return current && (current < moment().subtract(3, 'months') || current > moment().endOf('day'));
  };
  // 下拉选择
  handleChange(key, val) {
    const obj = {};
    obj[key] = val;
    this.setState({
      formFilter: Object.assign(this.state.formFilter, obj)
    }, () => {
      this.refreshData();
    });
  };
  // 日期选择
  dateChange = (date, dateString) => {
    this.setState({
      formFilter: Object.assign(this.state.formFilter, {
        startDate: dateString[0],
        endDate: dateString[1]
      })
    }, () => {
      this.refreshData();
    });
  };
  // 时间选择
  timeChange = (date, dateString) => {
    this.setState({
      tbFilter: Object.assign(this.state.tbFilter, {
        startTime: dateString[0],
        endTime: dateString[1]
      })
    }, () => {
      this.getVisitPageInfo();
    });
  };
  // 页数变化
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      tbFilter: Object.assign(this.state.tbFilter, {
        page: 1,
        size
      })
    }, () => {
      this.getVisitPageInfo();
    });
  };
  // 页数跳转 以及排序
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    this.setState({
      tbFilter: Object.assign(this.state.tbFilter, {
        page: pagination.current,
        size: pagination.pageSize
      })
    }, () => {
      this.getVisitPageInfo();
    });
  };
  // 更新数据
  refreshData() {
    const {url, statisticsType, startDate, endDate} = this.state.formFilter;
    if (!url || !statisticsType || !startDate || !endDate) {
      message.error('URL、时长、日期必须选择');
      return;
    }
    this.getVisitDetailStatistics();
    this.getVisitPageInfo();
  };
  render() {
    const {browserTypeList, statisticsTypeList, systemTypeList, urlList} = this.state.dataList;
    const {url, statisticsType, startDate, endDate} = this.state.formFilter;
    const {hourList, dayList, tbData, loading, pagination, tbFilter, formFilter} = this.state;
    return (
      <div className='page-interface-details'>
        <div className="page-top-filter">
          <Select value={url} style={{ width: 240 }} onChange={val => this.handleChange('url', val)}>
            {urlList.map(item => {
              return <Option key={item} value={item}>{item}</Option>
            })}
          </Select>
          <Select value={statisticsType} style={{ width: 140 }} onChange={val => this.handleChange('statisticsType', val)}>
            {statisticsTypeList.map(item => {
              return <Option key={item.code} value={item.code}>{item.name}</Option>
            })}
          </Select>
          <RangePicker disabledDate={this.disabledDate} onChange={this.dateChange} value={[moment(startDate), moment(endDate)]} allowClear={false} />
          <Select placeholder="全部浏览器版本" style={{ width: 140 }} onChange={val => this.handleChange('browserType', val)} allowClear>
            {browserTypeList.map(item => {
              return <Option key={item} value={item}>{item}</Option>
            })}
          </Select>
          <Select placeholder="系统分类" style={{ width: 120 }} onChange={val => this.handleChange('systemType', val)} allowClear>
            {systemTypeList.map(item => {
              return <Option key={item} value={item}>{item}</Option>
            })}
          </Select>
        </div>
        <InterfaceEcharts hourList={hourList} />
        <InterfaceEcharts2 dayList={dayList} />
        <ComTable loading={loading} pagination={pagination} pageChange={this.pageChange}
          timeChange={this.timeChange} tbFilter={tbFilter} formFilter={formFilter} tbData={tbData} />
      </div>
    );
  }
};
// storeState：将state映射到组件的props中
const storeState = (state) => {
  return {
    quantileTimeList: state.setQuantileTimeList
  }
};
export default connect(storeState)(interfaceDetails);
